import { render, staticRenderFns } from "./NewBookings.vue?vue&type=template&id=37ab7ff2"
import script from "./NewBookings.vue?vue&type=script&lang=js"
export * from "./NewBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports